<template>
  <Row>
    <div class="floor-title">
      <Icon type="ios-location-outline" /> {{ floor.houseFloorNumber }} 层
    </div>
    <room-card v-for="(item, index) in floor.subStockList" :key="index" :stock="item"></room-card>
  </Row>
</template>
<script>
  import roomCard from './roomCard'
  export default {
    name: "floorCard",
    props: {
      floor: Object
    },
    components: {
      roomCard
    },
    data () {
      return {}
    }
  }
</script>
<style scoped lang="less">
  .floor-title {
    border-bottom: 1px solid #e8eaec;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }
</style>
